var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _rect, _defs, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _rect2, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUnifiedOnboardingBackground = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 988,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 988",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384.706 205.118C386.943 208.547 386.965 213.277 384.943 218.99C382.923 224.694 378.891 231.298 373.161 238.382C361.704 252.547 343.522 268.555 321.326 283.035C299.131 297.516 277.153 307.707 259.573 312.486C250.781 314.876 243.112 315.905 237.078 315.455C231.035 315.004 226.714 313.079 224.477 309.65C222.24 306.221 222.219 301.491 224.241 295.778C226.26 290.074 230.292 283.47 236.022 276.386C247.479 262.221 265.661 246.213 287.857 231.733C310.053 217.253 332.03 207.061 349.61 202.282C358.403 199.892 366.071 198.863 372.106 199.313C378.149 199.764 382.47 201.689 384.706 205.118Z",
    stroke: "url(#paint0_linear_68_5424)",
    strokeWidth: 0.862163
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M408.139 171.1C411.567 176.354 411.808 183.407 409.192 191.742C406.577 200.072 401.125 209.618 393.276 219.778C377.581 240.095 352.36 262.791 321.33 283.035C290.3 303.279 259.366 317.218 234.447 323.397C221.985 326.487 211.052 327.631 202.374 326.667C193.692 325.703 187.334 322.641 183.906 317.386C180.478 312.132 180.237 305.079 182.853 296.744C185.468 288.414 190.919 278.868 198.768 268.708C214.464 248.391 239.684 225.695 270.715 205.451C301.745 185.207 332.679 171.268 357.598 165.089C370.059 161.999 380.992 160.855 389.671 161.819C398.353 162.783 404.711 165.845 408.139 171.1Z",
    stroke: "url(#paint1_linear_68_5424)",
    strokeWidth: 0.862163
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M434.182 132.736C438.965 140.068 439.483 149.753 436.224 161.06C432.965 172.365 425.944 185.236 415.739 198.866C395.331 226.123 362.25 256.338 321.328 283.035C280.407 309.732 239.424 327.835 206.255 335.531C189.668 339.38 175.06 340.62 163.399 339.048C151.737 337.475 143.082 333.099 138.299 325.767C133.516 318.435 132.998 308.75 136.257 297.443C139.516 286.138 146.537 273.267 156.742 259.637C177.15 232.38 210.231 202.164 251.152 175.468C292.074 148.771 333.057 130.668 366.226 122.972C382.813 119.123 397.421 117.883 409.082 119.455C420.744 121.028 429.399 125.404 434.182 132.736Z",
    stroke: "url(#paint2_linear_68_5424)",
    strokeWidth: 0.862163
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M458.066 96.3337C464.168 105.687 465 117.908 461.19 132.063C457.379 146.217 448.937 162.257 436.571 179.179C411.842 213.022 371.476 250.32 321.329 283.035C271.182 315.75 220.782 337.667 179.844 346.665C159.374 351.165 141.293 352.428 126.802 350.213C112.312 347.998 101.462 342.313 95.36 332.959C89.258 323.606 88.4263 311.385 92.237 297.23C96.0477 283.076 104.489 267.036 116.855 250.114C141.584 216.271 181.95 178.973 232.097 146.258C282.244 113.543 332.645 91.6258 373.582 82.6278C394.053 78.1285 412.134 76.8645 426.624 79.0799C441.115 81.2953 451.965 86.9804 458.066 96.3337Z",
    stroke: "url(#paint3_linear_68_5424)",
    strokeWidth: 0.862163
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M488.67 52.0472C496.31 63.7581 497.436 78.9863 492.845 96.5593C488.253 114.132 477.954 134.003 462.82 154.932C432.552 196.788 382.999 242.802 321.328 283.035C259.657 323.269 197.577 350.083 147.074 360.921C121.821 366.34 99.4851 367.76 81.5516 364.882C63.6182 362.004 50.1343 354.838 42.4943 343.127C34.8543 331.417 33.7283 316.188 38.3198 298.615C42.9112 281.042 53.2101 261.172 68.3448 240.243C98.6124 198.387 148.166 152.373 209.837 112.139C271.508 71.9057 333.587 45.0918 384.09 34.2537C409.344 28.8343 431.679 27.4143 449.613 30.2923C467.546 33.1703 481.03 40.3364 488.67 52.0472Z",
    stroke: "url(#paint4_linear_68_5424)",
    strokeWidth: 0.862163
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M502.152 14.4098C511.623 28.9276 513.728 47.316 509.363 68.1858C504.998 89.0579 494.166 112.38 477.813 136.711C445.107 185.372 390.365 237.998 321.331 283.035C252.296 328.072 182.075 356.971 124.361 367.299C95.5033 372.463 69.7941 372.98 48.9322 368.566C28.0726 364.152 12.0909 354.817 2.6196 340.299C-6.85166 325.781 -8.95636 307.393 -4.5914 286.523C-0.225937 265.651 10.6057 242.329 26.959 217.998C59.6645 169.337 114.407 116.711 183.441 71.6739C252.475 26.6367 322.697 -2.26219 380.41 -12.5898C409.268 -17.7538 434.978 -18.2707 455.839 -13.8567C476.699 -9.44309 492.681 -0.107965 502.152 14.4098Z",
    stroke: "url(#paint5_linear_68_5424)",
    strokeWidth: 0.862163
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M523.711 -34.0424C546.86 1.44202 536.14 54.5732 499.462 112.052C462.83 169.457 400.487 230.881 321.096 282.674C241.706 334.468 160.369 366.779 93.0708 377.177C25.6861 387.588 -27.2609 375.992 -50.4105 340.508C-73.5602 305.023 -62.8401 251.892 -26.1617 194.414C10.4698 137.009 72.8134 75.585 152.204 23.7914C231.595 -28.0022 312.931 -60.3136 380.229 -70.7113C447.614 -81.1224 500.561 -69.5269 523.711 -34.0424Z",
    stroke: "url(#paint6_linear_68_5424)",
    strokeWidth: 1.72433
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M559.326 -89.8541C586.592 -48.0594 573.944 14.4738 530.821 82.0524C487.744 149.557 414.438 221.779 321.096 282.674C227.754 343.57 132.119 381.564 52.9793 393.791C-26.246 406.031 -88.575 392.412 -115.841 350.617C-143.108 308.823 -130.46 246.289 -87.3363 178.711C-44.2597 111.206 29.0459 38.9842 122.388 -21.9111C215.73 -82.8065 311.366 -120.8 390.505 -133.027C469.73 -145.268 532.059 -131.649 559.326 -89.8541Z",
    stroke: "url(#paint7_linear_68_5424)",
    strokeWidth: 1.72433
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 389.24,
    cy: 161.469,
    r: 4.84777,
    transform: "rotate(-2.46778 389.24 161.469)",
    fill: "#FFEADB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1101.51 758.268C1098.97 755.126 1098.46 750.479 1099.87 744.659C1101.28 738.847 1104.57 731.946 1109.49 724.401C1119.31 709.314 1135.56 691.732 1155.91 675.245C1176.26 658.757 1196.83 646.509 1213.63 640.027C1222.03 636.786 1229.47 634.996 1235.44 634.826C1241.43 634.656 1245.87 636.11 1248.42 639.252C1250.96 642.394 1251.46 647.041 1250.05 652.861C1248.65 658.674 1245.35 665.574 1240.44 673.12C1230.62 688.206 1214.37 705.789 1194.01 722.276C1173.66 738.763 1153.09 751.011 1136.3 757.493C1127.89 760.735 1120.46 762.525 1114.48 762.694C1108.5 762.864 1104.06 761.41 1101.51 758.268Z",
    stroke: "url(#paint8_linear_68_5424)",
    strokeWidth: 0.862163
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1080.6 794.937C1076.65 790.062 1075.68 783.071 1077.43 774.512C1079.17 765.957 1083.62 755.902 1090.38 744.989C1103.91 723.168 1126.67 698.003 1155.45 674.68C1184.24 651.358 1213.58 634.317 1237.73 625.612C1249.81 621.259 1260.57 618.999 1269.3 619.066C1278.04 619.133 1284.68 621.527 1288.62 626.402C1292.57 631.277 1293.54 638.268 1291.79 646.827C1290.05 655.382 1285.6 665.437 1278.84 676.349C1265.31 698.17 1242.55 723.336 1213.77 746.658C1184.98 769.981 1155.64 787.022 1131.49 795.727C1119.41 800.08 1108.65 802.34 1099.92 802.272C1091.18 802.205 1084.55 799.812 1080.6 794.937Z",
    stroke: "url(#paint9_linear_68_5424)",
    strokeWidth: 0.862163
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.63 835.772C1053.12 828.97 1051.61 819.389 1053.69 807.807C1055.77 796.227 1061.43 782.703 1070.18 768.098C1087.68 738.89 1117.49 705.438 1155.45 674.68C1193.42 643.923 1232.33 621.709 1264.53 610.648C1280.63 605.117 1295.04 602.383 1306.8 602.75C1318.56 603.117 1327.62 606.582 1333.13 613.384C1338.64 620.186 1340.15 629.766 1338.07 641.348C1335.99 652.929 1330.32 666.452 1321.57 681.058C1304.07 710.266 1274.27 743.718 1236.3 774.475C1198.34 805.232 1159.43 827.447 1127.23 838.508C1111.12 844.039 1096.72 846.772 1084.96 846.405C1073.2 846.038 1064.14 842.574 1058.63 835.772Z",
    stroke: "url(#paint10_linear_68_5424)",
    strokeWidth: 0.862163
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1038.61 874.433C1031.58 865.756 1029.5 853.685 1031.83 839.214C1034.17 824.743 1040.92 807.922 1051.48 789.819C1072.61 753.616 1108.93 712.371 1155.45 674.68C1201.98 636.99 1249.86 610.014 1289.66 596.861C1309.56 590.284 1327.41 587.17 1342.06 587.886C1356.7 588.602 1368.07 593.143 1375.1 601.821C1382.13 610.498 1384.22 622.569 1381.88 637.04C1379.54 651.511 1372.79 668.332 1362.23 686.435C1341.1 722.637 1304.78 763.883 1258.26 801.574C1211.73 839.264 1163.85 866.24 1124.05 879.393C1104.15 885.97 1086.3 889.084 1071.65 888.368C1057.01 887.652 1045.64 883.111 1038.61 874.433Z",
    stroke: "url(#paint11_linear_68_5424)",
    strokeWidth: 0.862163
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.71 921.628C1003.91 910.763 1001.23 895.731 1003.99 877.78C1006.75 859.828 1014.96 839.005 1027.86 816.633C1053.68 771.891 1098.24 721.032 1155.46 674.68C1212.67 628.328 1271.67 595.282 1320.79 579.316C1345.36 571.333 1367.43 567.627 1385.56 568.649C1403.7 569.67 1417.85 575.414 1426.65 586.279C1435.45 597.143 1438.13 612.176 1435.37 630.127C1432.61 648.079 1424.4 668.902 1411.5 691.274C1385.69 736.016 1341.12 786.874 1283.9 833.227C1226.69 879.579 1167.69 912.625 1118.57 928.591C1094 936.574 1071.93 940.28 1053.8 939.258C1035.66 938.236 1021.52 932.493 1012.71 921.628Z",
    stroke: "url(#paint12_linear_68_5424)",
    strokeWidth: 0.862163
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1003.17 960.451C992.255 946.982 988.274 928.907 990.473 907.699C992.673 886.489 1001.05 862.178 1014.82 836.297C1042.36 784.535 1091.41 726.567 1155.45 674.681C1219.5 622.794 1286.38 586.838 1342.73 570.64C1370.91 562.541 1396.43 559.387 1417.63 561.636C1438.83 563.885 1455.69 571.53 1466.6 584.998C1477.51 598.467 1481.5 616.542 1479.3 637.75C1477.1 658.96 1468.72 683.27 1454.95 709.152C1427.41 760.914 1378.36 818.882 1314.31 870.768C1250.27 922.655 1183.39 958.611 1127.04 974.809C1098.86 982.908 1073.34 986.062 1052.14 983.813C1030.93 981.564 1014.08 973.919 1003.17 960.451Z",
    stroke: "url(#paint13_linear_68_5424)",
    strokeWidth: 0.862163
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M986.532 1011C959.775 977.969 965.038 923.905 995.628 862.951C1026.19 802.055 1081.92 734.533 1155.59 674.848C1229.26 615.162 1306.88 574.654 1372.79 557.393C1438.77 540.115 1492.74 546.183 1519.5 579.21C1546.26 612.237 1540.99 666.3 1510.4 727.254C1479.84 788.15 1424.11 855.672 1350.44 915.358C1276.77 975.043 1199.15 1015.55 1133.24 1032.81C1067.27 1050.09 1013.29 1044.02 986.532 1011Z",
    stroke: "url(#paint14_linear_68_5424)",
    strokeWidth: 1.29324
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M957.002 1070.03C925.588 1031.26 931.75 967.757 967.707 896.108C1003.63 824.537 1069.13 745.172 1155.73 675.015C1242.32 604.858 1333.55 557.247 1411.02 536.959C1488.57 516.65 1551.97 523.798 1583.38 562.572C1614.79 601.347 1608.63 664.848 1572.67 736.497C1536.76 808.068 1471.25 887.434 1384.66 957.59C1298.06 1027.75 1206.83 1075.36 1129.36 1095.65C1051.81 1115.96 988.415 1108.81 957.002 1070.03Z",
    stroke: "url(#paint15_linear_68_5424)",
    strokeWidth: 1.72433
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1231.43,
    cy: 711.643,
    r: 1.14717,
    transform: "rotate(-8.36048 1231.43 711.643)",
    fill: "#CFD7D6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1255.59,
    cy: 876.07,
    r: 1.14717,
    transform: "rotate(-8.36048 1255.59 876.07)",
    fill: "#CFD7D6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1232.14,
    cy: 634.547,
    r: 2.69363,
    transform: "rotate(-8.36048 1232.14 634.547)",
    fill: "#FC5200"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1073.92,
    cy: 887.969,
    r: 3.62736,
    transform: "rotate(-8.36048 1073.92 887.969)",
    fill: "#FC5200"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1439.38,
    cy: 830.33,
    r: 4.84777,
    transform: "rotate(-8.36048 1439.38 830.33)",
    fill: "#FC5200"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1099.45,
    cy: 753.911,
    r: 3.53979,
    transform: "rotate(-8.36048 1099.45 753.911)",
    fill: "#FC5200"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1418.62,
    cy: 602.31,
    r: 0.761128,
    transform: "rotate(-8.36048 1418.62 602.31)",
    fill: "#CFD7D6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -10.4094,
    width: 1466.29,
    height: 1009.99,
    fill: "url(#paint16_radial_68_5424)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_68_5424",
    x1: 323.546,
    y1: 286.377,
    x2: 218.214,
    y2: 206.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEADB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_68_5424",
    x1: 324.549,
    y1: 287.884,
    x2: 164.592,
    y2: 172.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEADB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_68_5424",
    x1: 325.688,
    y1: 289.604,
    x2: 103.353,
    y2: 134.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEADB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_68_5424",
    x1: 326.799,
    y1: 291.28,
    x2: 43.5188,
    y2: 99.3988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEADB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_68_5424",
    x1: 328.095,
    y1: 293.238,
    x2: -25.952,
    y2: 56.1735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEADB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_68_5424",
    x1: 329.629,
    y1: 295.564,
    x2: -111.06,
    y2: 23.4712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEADB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_68_5424",
    x1: 331.457,
    y1: 298.336,
    x2: -211.049,
    y2: -17.8519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEADB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_68_5424",
    x1: 333.193,
    y1: 300.959,
    x2: -304.554,
    y2: -70.7385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEADB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_68_5424",
    x1: 1162.9,
    y1: 675.38,
    x2: 1296.38,
    y2: 791.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.171141,
    stopColor: "#FC5200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515645,
    stopColor: "#15252D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_68_5424",
    x1: 1165.78,
    y1: 675.428,
    x2: 1370.87,
    y2: 849.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.171141,
    stopColor: "#FC5200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515645,
    stopColor: "#15252D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_68_5424",
    x1: 1169.46,
    y1: 676.149,
    x2: 1454.71,
    y2: 914.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.171141,
    stopColor: "#FC5200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515645,
    stopColor: "#15252D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_68_5424",
    x1: 1172.97,
    y1: 676.914,
    x2: 1536.73,
    y2: 976.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.171141,
    stopColor: "#FC5200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515645,
    stopColor: "#15252D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_68_5424",
    x1: 1177.21,
    y1: 677.693,
    x2: 1632.06,
    y2: 1049.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.171141,
    stopColor: "#FC5200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515645,
    stopColor: "#15252D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_68_5424",
    x1: 1181.05,
    y1: 679.582,
    x2: 1749.92,
    y2: 1125.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.171141,
    stopColor: "#FC5200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515645,
    stopColor: "#15252D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_68_5424",
    x1: 1185.93,
    y1: 681.586,
    x2: 1889.64,
    y2: 1216.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.171141,
    stopColor: "#FC5200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515645,
    stopColor: "#15252D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_68_5424",
    x1: 1191.32,
    y1: 682.857,
    x2: 2018.58,
    y2: 1311.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.171141,
    stopColor: "#FC5200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515645,
    stopColor: "#15252D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_68_5424",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(714.754 544.432) rotate(-90.7095) scale(1027.86 2254.09)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.010274,
    stopColor: "#15252D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15252D"
  })))));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 988,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 988",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M384.706 205.118C386.943 208.547 386.965 213.277 384.943 218.99C382.923 224.694 378.891 231.298 373.161 238.382C361.704 252.547 343.522 268.555 321.326 283.035C299.131 297.516 277.153 307.707 259.573 312.486C250.781 314.876 243.112 315.905 237.078 315.455C231.035 315.004 226.714 313.079 224.477 309.65C222.24 306.221 222.219 301.491 224.241 295.778C226.26 290.074 230.292 283.47 236.022 276.386C247.479 262.221 265.661 246.213 287.857 231.733C310.053 217.253 332.03 207.061 349.61 202.282C358.403 199.892 366.071 198.863 372.106 199.313C378.149 199.764 382.47 201.689 384.706 205.118Z",
    stroke: "url(#paint0_linear_68_5424)",
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.139 171.1C411.567 176.354 411.808 183.407 409.192 191.742C406.577 200.072 401.125 209.618 393.276 219.778C377.581 240.095 352.36 262.791 321.33 283.035C290.3 303.279 259.366 317.218 234.447 323.397C221.985 326.487 211.052 327.631 202.374 326.667C193.692 325.703 187.334 322.641 183.906 317.386C180.478 312.132 180.237 305.079 182.853 296.744C185.468 288.414 190.919 278.868 198.768 268.708C214.464 248.391 239.684 225.695 270.715 205.451C301.745 185.207 332.679 171.268 357.598 165.089C370.059 161.999 380.992 160.855 389.671 161.819C398.353 162.783 404.711 165.845 408.139 171.1Z",
    stroke: "url(#paint1_linear_68_5424)",
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.182 132.736C438.965 140.068 439.483 149.753 436.224 161.06C432.965 172.365 425.944 185.236 415.739 198.866C395.331 226.123 362.25 256.338 321.328 283.035C280.407 309.732 239.424 327.835 206.255 335.531C189.668 339.38 175.06 340.62 163.399 339.048C151.737 337.475 143.082 333.099 138.299 325.767C133.516 318.435 132.998 308.75 136.257 297.443C139.516 286.138 146.537 273.267 156.742 259.637C177.15 232.38 210.231 202.164 251.152 175.468C292.074 148.771 333.057 130.668 366.226 122.972C382.813 119.123 397.421 117.883 409.082 119.455C420.744 121.028 429.399 125.404 434.182 132.736Z",
    stroke: "url(#paint2_linear_68_5424)",
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.066 96.3337C464.168 105.687 465 117.908 461.19 132.063C457.379 146.217 448.937 162.257 436.571 179.179C411.842 213.022 371.476 250.32 321.329 283.035C271.182 315.75 220.782 337.667 179.844 346.665C159.374 351.165 141.293 352.428 126.802 350.213C112.312 347.998 101.462 342.313 95.36 332.959C89.258 323.606 88.4263 311.385 92.237 297.23C96.0477 283.076 104.489 267.036 116.855 250.114C141.584 216.271 181.95 178.973 232.097 146.258C282.244 113.543 332.645 91.6258 373.582 82.6278C394.053 78.1285 412.134 76.8645 426.624 79.0799C441.115 81.2953 451.965 86.9804 458.066 96.3337Z",
    stroke: "url(#paint3_linear_68_5424)",
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.67 52.0472C496.31 63.7581 497.436 78.9863 492.845 96.5593C488.253 114.132 477.954 134.003 462.82 154.932C432.552 196.788 382.999 242.802 321.328 283.035C259.657 323.269 197.577 350.083 147.074 360.921C121.821 366.34 99.4851 367.76 81.5516 364.882C63.6182 362.004 50.1343 354.838 42.4943 343.127C34.8543 331.417 33.7283 316.188 38.3198 298.615C42.9112 281.042 53.2101 261.172 68.3448 240.243C98.6124 198.387 148.166 152.373 209.837 112.139C271.508 71.9057 333.587 45.0918 384.09 34.2537C409.344 28.8343 431.679 27.4143 449.613 30.2923C467.546 33.1703 481.03 40.3364 488.67 52.0472Z",
    stroke: "url(#paint4_linear_68_5424)",
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.152 14.4098C511.623 28.9276 513.728 47.316 509.363 68.1858C504.998 89.0579 494.166 112.38 477.813 136.711C445.107 185.372 390.365 237.998 321.331 283.035C252.296 328.072 182.075 356.971 124.361 367.299C95.5033 372.463 69.7941 372.98 48.9322 368.566C28.0726 364.152 12.0909 354.817 2.6196 340.299C-6.85166 325.781 -8.95636 307.393 -4.5914 286.523C-0.225937 265.651 10.6057 242.329 26.959 217.998C59.6645 169.337 114.407 116.711 183.441 71.6739C252.475 26.6367 322.697 -2.26219 380.41 -12.5898C409.268 -17.7538 434.978 -18.2707 455.839 -13.8567C476.699 -9.44309 492.681 -0.107965 502.152 14.4098Z",
    stroke: "url(#paint5_linear_68_5424)",
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.711 -34.0424C546.86 1.44202 536.14 54.5732 499.462 112.052C462.83 169.457 400.487 230.881 321.096 282.674C241.706 334.468 160.369 366.779 93.0708 377.177C25.6861 387.588 -27.2609 375.992 -50.4105 340.508C-73.5602 305.023 -62.8401 251.892 -26.1617 194.414C10.4698 137.009 72.8134 75.585 152.204 23.7914C231.595 -28.0022 312.931 -60.3136 380.229 -70.7113C447.614 -81.1224 500.561 -69.5269 523.711 -34.0424Z",
    stroke: "url(#paint6_linear_68_5424)",
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.326 -89.8541C586.592 -48.0594 573.944 14.4738 530.821 82.0524C487.744 149.557 414.438 221.779 321.096 282.674C227.754 343.57 132.119 381.564 52.9793 393.791C-26.246 406.031 -88.575 392.412 -115.841 350.617C-143.108 308.823 -130.46 246.289 -87.3363 178.711C-44.2597 111.206 29.0459 38.9842 122.388 -21.9111C215.73 -82.8065 311.366 -120.8 390.505 -133.027C469.73 -145.268 532.059 -131.649 559.326 -89.8541Z",
    stroke: "url(#paint7_linear_68_5424)",
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 389.24,
    cy: 161.469,
    r: 4.84777,
    transform: "rotate(-2.46778 389.24 161.469)",
    fill: "#FFEADB"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1101.51 758.268C1098.97 755.126 1098.46 750.479 1099.87 744.659C1101.28 738.847 1104.57 731.946 1109.49 724.401C1119.31 709.314 1135.56 691.732 1155.91 675.245C1176.26 658.757 1196.83 646.509 1213.63 640.027C1222.03 636.786 1229.47 634.996 1235.44 634.826C1241.43 634.656 1245.87 636.11 1248.42 639.252C1250.96 642.394 1251.46 647.041 1250.05 652.861C1248.65 658.674 1245.35 665.574 1240.44 673.12C1230.62 688.206 1214.37 705.789 1194.01 722.276C1173.66 738.763 1153.09 751.011 1136.3 757.493C1127.89 760.735 1120.46 762.525 1114.48 762.694C1108.5 762.864 1104.06 761.41 1101.51 758.268Z",
    stroke: "url(#paint8_linear_68_5424)",
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080.6 794.937C1076.65 790.062 1075.68 783.071 1077.43 774.512C1079.17 765.957 1083.62 755.902 1090.38 744.989C1103.91 723.168 1126.67 698.003 1155.45 674.68C1184.24 651.358 1213.58 634.317 1237.73 625.612C1249.81 621.259 1260.57 618.999 1269.3 619.066C1278.04 619.133 1284.68 621.527 1288.62 626.402C1292.57 631.277 1293.54 638.268 1291.79 646.827C1290.05 655.382 1285.6 665.437 1278.84 676.349C1265.31 698.17 1242.55 723.336 1213.77 746.658C1184.98 769.981 1155.64 787.022 1131.49 795.727C1119.41 800.08 1108.65 802.34 1099.92 802.272C1091.18 802.205 1084.55 799.812 1080.6 794.937Z",
    stroke: "url(#paint9_linear_68_5424)",
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.63 835.772C1053.12 828.97 1051.61 819.389 1053.69 807.807C1055.77 796.227 1061.43 782.703 1070.18 768.098C1087.68 738.89 1117.49 705.438 1155.45 674.68C1193.42 643.923 1232.33 621.709 1264.53 610.648C1280.63 605.117 1295.04 602.383 1306.8 602.75C1318.56 603.117 1327.62 606.582 1333.13 613.384C1338.64 620.186 1340.15 629.766 1338.07 641.348C1335.99 652.929 1330.32 666.452 1321.57 681.058C1304.07 710.266 1274.27 743.718 1236.3 774.475C1198.34 805.232 1159.43 827.447 1127.23 838.508C1111.12 844.039 1096.72 846.772 1084.96 846.405C1073.2 846.038 1064.14 842.574 1058.63 835.772Z",
    stroke: "url(#paint10_linear_68_5424)",
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.61 874.433C1031.58 865.756 1029.5 853.685 1031.83 839.214C1034.17 824.743 1040.92 807.922 1051.48 789.819C1072.61 753.616 1108.93 712.371 1155.45 674.68C1201.98 636.99 1249.86 610.014 1289.66 596.861C1309.56 590.284 1327.41 587.17 1342.06 587.886C1356.7 588.602 1368.07 593.143 1375.1 601.821C1382.13 610.498 1384.22 622.569 1381.88 637.04C1379.54 651.511 1372.79 668.332 1362.23 686.435C1341.1 722.637 1304.78 763.883 1258.26 801.574C1211.73 839.264 1163.85 866.24 1124.05 879.393C1104.15 885.97 1086.3 889.084 1071.65 888.368C1057.01 887.652 1045.64 883.111 1038.61 874.433Z",
    stroke: "url(#paint11_linear_68_5424)",
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.71 921.628C1003.91 910.763 1001.23 895.731 1003.99 877.78C1006.75 859.828 1014.96 839.005 1027.86 816.633C1053.68 771.891 1098.24 721.032 1155.46 674.68C1212.67 628.328 1271.67 595.282 1320.79 579.316C1345.36 571.333 1367.43 567.627 1385.56 568.649C1403.7 569.67 1417.85 575.414 1426.65 586.279C1435.45 597.143 1438.13 612.176 1435.37 630.127C1432.61 648.079 1424.4 668.902 1411.5 691.274C1385.69 736.016 1341.12 786.874 1283.9 833.227C1226.69 879.579 1167.69 912.625 1118.57 928.591C1094 936.574 1071.93 940.28 1053.8 939.258C1035.66 938.236 1021.52 932.493 1012.71 921.628Z",
    stroke: "url(#paint12_linear_68_5424)",
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.17 960.451C992.255 946.982 988.274 928.907 990.473 907.699C992.673 886.489 1001.05 862.178 1014.82 836.297C1042.36 784.535 1091.41 726.567 1155.45 674.681C1219.5 622.794 1286.38 586.838 1342.73 570.64C1370.91 562.541 1396.43 559.387 1417.63 561.636C1438.83 563.885 1455.69 571.53 1466.6 584.998C1477.51 598.467 1481.5 616.542 1479.3 637.75C1477.1 658.96 1468.72 683.27 1454.95 709.152C1427.41 760.914 1378.36 818.882 1314.31 870.768C1250.27 922.655 1183.39 958.611 1127.04 974.809C1098.86 982.908 1073.34 986.062 1052.14 983.813C1030.93 981.564 1014.08 973.919 1003.17 960.451Z",
    stroke: "url(#paint13_linear_68_5424)",
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.532 1011C959.775 977.969 965.038 923.905 995.628 862.951C1026.19 802.055 1081.92 734.533 1155.59 674.848C1229.26 615.162 1306.88 574.654 1372.79 557.393C1438.77 540.115 1492.74 546.183 1519.5 579.21C1546.26 612.237 1540.99 666.3 1510.4 727.254C1479.84 788.15 1424.11 855.672 1350.44 915.358C1276.77 975.043 1199.15 1015.55 1133.24 1032.81C1067.27 1050.09 1013.29 1044.02 986.532 1011Z",
    stroke: "url(#paint14_linear_68_5424)",
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.002 1070.03C925.588 1031.26 931.75 967.757 967.707 896.108C1003.63 824.537 1069.13 745.172 1155.73 675.015C1242.32 604.858 1333.55 557.247 1411.02 536.959C1488.57 516.65 1551.97 523.798 1583.38 562.572C1614.79 601.347 1608.63 664.848 1572.67 736.497C1536.76 808.068 1471.25 887.434 1384.66 957.59C1298.06 1027.75 1206.83 1075.36 1129.36 1095.65C1051.81 1115.96 988.415 1108.81 957.002 1070.03Z",
    stroke: "url(#paint15_linear_68_5424)",
    strokeWidth: weight === "normal" ? 1.5 : 1
  }), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 1231.43,
    cy: 711.643,
    r: 1.14717,
    transform: "rotate(-8.36048 1231.43 711.643)",
    fill: "#CFD7D6"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 1255.59,
    cy: 876.07,
    r: 1.14717,
    transform: "rotate(-8.36048 1255.59 876.07)",
    fill: "#CFD7D6"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 1232.14,
    cy: 634.547,
    r: 2.69363,
    transform: "rotate(-8.36048 1232.14 634.547)",
    fill: "#FC5200"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 1073.92,
    cy: 887.969,
    r: 3.62736,
    transform: "rotate(-8.36048 1073.92 887.969)",
    fill: "#FC5200"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 1439.38,
    cy: 830.33,
    r: 4.84777,
    transform: "rotate(-8.36048 1439.38 830.33)",
    fill: "#FC5200"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 1099.45,
    cy: 753.911,
    r: 3.53979,
    transform: "rotate(-8.36048 1099.45 753.911)",
    fill: "#FC5200"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 1418.62,
    cy: 602.31,
    r: 0.761128,
    transform: "rotate(-8.36048 1418.62 602.31)",
    fill: "#CFD7D6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: -10.4094,
    width: 1466.29,
    height: 1009.99,
    fill: "url(#paint16_radial_68_5424)"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_68_5424",
    x1: 323.546,
    y1: 286.377,
    x2: 218.214,
    y2: 206.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEADB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_68_5424",
    x1: 324.549,
    y1: 287.884,
    x2: 164.592,
    y2: 172.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEADB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_68_5424",
    x1: 325.688,
    y1: 289.604,
    x2: 103.353,
    y2: 134.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEADB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_68_5424",
    x1: 326.799,
    y1: 291.28,
    x2: 43.5188,
    y2: 99.3988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEADB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_68_5424",
    x1: 328.095,
    y1: 293.238,
    x2: -25.952,
    y2: 56.1735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEADB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_68_5424",
    x1: 329.629,
    y1: 295.564,
    x2: -111.06,
    y2: 23.4712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEADB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_68_5424",
    x1: 331.457,
    y1: 298.336,
    x2: -211.049,
    y2: -17.8519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEADB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_68_5424",
    x1: 333.193,
    y1: 300.959,
    x2: -304.554,
    y2: -70.7385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEADB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_68_5424",
    x1: 1162.9,
    y1: 675.38,
    x2: 1296.38,
    y2: 791.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.171141,
    stopColor: "#FC5200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515645,
    stopColor: "#15252D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_68_5424",
    x1: 1165.78,
    y1: 675.428,
    x2: 1370.87,
    y2: 849.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.171141,
    stopColor: "#FC5200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515645,
    stopColor: "#15252D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_68_5424",
    x1: 1169.46,
    y1: 676.149,
    x2: 1454.71,
    y2: 914.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.171141,
    stopColor: "#FC5200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515645,
    stopColor: "#15252D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_68_5424",
    x1: 1172.97,
    y1: 676.914,
    x2: 1536.73,
    y2: 976.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.171141,
    stopColor: "#FC5200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515645,
    stopColor: "#15252D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_68_5424",
    x1: 1177.21,
    y1: 677.693,
    x2: 1632.06,
    y2: 1049.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.171141,
    stopColor: "#FC5200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515645,
    stopColor: "#15252D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_68_5424",
    x1: 1181.05,
    y1: 679.582,
    x2: 1749.92,
    y2: 1125.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.171141,
    stopColor: "#FC5200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515645,
    stopColor: "#15252D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_68_5424",
    x1: 1185.93,
    y1: 681.586,
    x2: 1889.64,
    y2: 1216.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.171141,
    stopColor: "#FC5200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515645,
    stopColor: "#15252D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_68_5424",
    x1: 1191.32,
    y1: 682.857,
    x2: 2018.58,
    y2: 1311.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.171141,
    stopColor: "#FC5200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515645,
    stopColor: "#15252D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_68_5424",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(714.754 544.432) rotate(-90.7095) scale(1027.86 2254.09)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.010274,
    stopColor: "#15252D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15252D"
  })))));
});
export default SvgUnifiedOnboardingBackground;
export const raw = __webpack_public_path__ + "static/media/unified-onboarding-background.57c511a283a95c4e2b9430ef8aaec477.svg";